const id = {
  deleteTemplateTitle: "Hapus Template",
  deleteTemplateContent:
    "Template ini akan dihapus dan tidak dapat dipulihkan kembali.",
  deleteTemplateActionCancel: "Batalkan",
  deleteTemplateActionConfirm: "Ya, Hapus",
  deleteTemplateSuccessText: "Template berhasil dihapus",
  deleteTemplateFailedText: "Gagal menghapus template",
};

const en = {
  deleteTemplateTitle: "Delete Template",
  deleteTemplateContent:
    "This template will be deleted and cannot be recovered.",
  deleteTemplateActionCancel: "Cancel",
  deleteTemplateActionConfirm: "Yes, Delete",
  deleteTemplateSuccessText: "Template deleted successfully",
  deleteTemplateFailedText: "Failed to delete template",
};

export default { id, en };
